import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 0 }
  }

  connect() {
    this.timeout = null
  }

  handleEvent(event) {
    if (this.delayValue > 0) {
      clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        this.element.requestSubmit()
      }, this.delayValue)
    } else {
      this.element.requestSubmit()
    }
  }
}
